<ng-select
  [placeholder]="placeholder"
  [items]="items"
  [active]="active"
  (selected)="selected($event)"
  (opened)="opened($event)"
  >
</ng-select>
<t-icon name="expand_more" [hidden]="open"></t-icon>
<t-icon name="expand_less" [hidden]="!open"></t-icon>